export default {
  ANALYTICS: {
    TRACKER_ID: 'UA-79384491-1',
  },
  AIRFLOW_URL: 'https://af.optimization.choreograph.com',
  MAPBOX_PUBLIC_TOKEN: 'pk.eyJ1IjoieGF4Y29waWxvdGVuZ2luZWVycyIsImEiOiJja2JsYjFsZTAwZHdlMnhvNjE2dTNqeno3In0.lVY-Rc2aNU7cNz3KXGRivg',
  ENV: 'prod',
};
